module.exports = __webpack_public_path__ + "img/bannerPay.18cfb376.png";